import { Colors } from '../consts/Colors'

export const TextContents = {
    popup: {
        text: "Dans cette première étape, reconstituez les deux formules permettant de calculer la Trésorerie nette en replaçant les différents éléments proposés.",
    },
    consigne : {
        text : "Reconstituez les deux formules permettant de calculer la Trésorerie nette en replaçant les différents éléments proposés.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    title : {
        text : "TRÉSORERIE NETTE, FONDS DE ROULEMENT ET BESOIN EN FONDS DE ROULEMENT",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique24\'>ÉTAPE 1 :</class> Trésorerie nette",
        config: { size: '24px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    popupFin : {
        text : "Bravo, vous avez correctement reconstitué les deux formules permettant de calculer la Trésorerie nette.",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    
}

export const CartesInfos = [
    {
        titre: "La caisse",
        index: 1,
        image: "caisse",
        angle: 0,
        zoneId: 0,
        typeId: 0,
        correct: "La trésorerie nette correspond aux liquidités disponibles, par exemple dans la caisse, moins les dettes financières à court terme.",
        incorrect : "L'argent détenu dans la caisse n'est pas une dette mais fait partie des liquidités disponibles.",
        zoneX: 410,
        zoneY: 520
    },
    {
        titre: "Le compte bancaire",
        index: 2,
        image: "compteBancaire",
        angle: 0,
        zoneId: 0,
        typeId: 0,
        correct: "La trésorerie nette correspond aux liquidités disponibles, par exemple sur les comptes bancaires, moins les dettes financières à court terme.",
        incorrect : "L'argent placé sur les comptes bancaires de l'entreprise n'est pas une dette mais fait partie des liquidités disponibles.",
        zoneX: 610,
        zoneY: 520
    },
    {
        titre: "Découvert bancaire « non autorisé »",
        index: 3,
        image: "decouvert",
        angle: 0,
        zoneId: 1,
        typeId: 0,
        correct: "La trésorerie nette correspond aux liquidités disponibles moins les dettes financières à court terme (découvert bancaire par exemple).",
        incorrect : "Le découvert bancaire ne fait pas partie des liquidités disponibles. C'est une dette financière à court terme.",
        zoneX: 995,
        zoneY: 520
    },
    {
        titre: "Fonds de Roulement (FR)",
        index: 4,
        image: "fondRoulement",
        angle: -1,
        zoneId: 2,
        typeId: 1,
        correct: "La trésorerie nette s'obtient par différence entre le Fonds de Roulement et le Besoin en Fonds de Roulement.",
        incorrect : "La trésorerie nette s'obtient par différence entre le Fonds de Roulement et le Besoin en Fonds de Roulement.",
        zoneX: 475,
        zoneY: 980
    },
    {
        titre: "Besoin en Fonds de Roulement (BFR)",
        index: 5,
        image: "besoinFondRoulement",
        angle: 2,
        zoneId: 3,
        typeId: 1,
        correct: "La trésorerie nette s'obtient par différence entre le Fonds de Roulement et le Besoin en Fonds de Roulement.",
        incorrect : "La trésorerie nette s'obtient par différence entre le Fonds de Roulement et le Besoin en Fonds de Roulement.",
        zoneX: 960,
        zoneY: 980
    }
]

export const ZonesInfos = [
    {
        index: 1,
        zoneX: 520,
        zoneY: 560,
        zoneId: 0,
        typeId: 0,
        image: "zone_liquidite"
    },
    {
        index: 2,
        zoneX: 990,
        zoneY: 560,
        zoneId: 1,
        typeId: 0,
        image: "zone_dettes"
    },
    {
        index: 3,
        zoneX: 475,
        zoneY: 980,
        zoneId: 2,
        typeId: 1,
        image: "zone_rectangulaire"
    },
    {
        index: 4,
        zoneX: 960,
        zoneY: 980,
        zoneId: 3,
        typeId: 1,
        image: "zone_rectangulaire"
    },
]